import { STORE_URL, ASSETS } from "../data/content";
import { trackOutboundClick } from "../lib/analytics";

/**
 * Official Google Play "Get it on" badge using the user-provided asset.
 * Single source of truth for the download CTA.
 */
export default function GooglePlayBadge({
  className = "",
  size = "md",
  testId = "google-play-badge",
}) {
  const heights = { sm: "h-14", md: "h-16", lg: "h-20" };
  return (
    <a
      href={STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label="Get it on Google Play"
      onClick={() => trackOutboundClick(testId, STORE_URL, { placement: testId })}
      className={`scope-halo inline-flex items-center justify-center rounded-xl transition-all duration-300 hover:-translate-y-0.5 hover:drop-shadow-[0_8px_24px_rgba(217,119,54,0.35)] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]/60 ${className}`}
    >
      <img
        src={ASSETS.googlePlayBadge}
        alt="Get it on Google Play"
        className={`${heights[size]} w-auto select-none`}
        draggable="false"
      />
    </a>
  );
}
